export default "__VITE_ASSET__DecVzFcF__"